<style lang="scss">
.notify {
    text-align: center;
}
</style>

<template>
    <div class="notify">
        Новых уведомлений нет 😢
    </div>
</template>